import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowX: "hidden",
  },
  icon: {
    display: "flex",
    float: "right",
    width: "10vh",
    height: "12.5vh",
    alignContent: "center",
    alignItems: "center",
  },
  btnt: {
    padding: "4px 16px",
    minWidth: "auto",
  },
  btnSelect: {
    borderRadius: 100,
    marginRight: 10,
    marginBottom: 15,
    color: "grey",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    // fontWeight: "bold",
    fontSize: 10,
    backgroundColor: "lightgray",
    minWidth: 90,
    borderWidth: 0,
  },
  btnSelectSelected: {
    borderRadius: 100,
    marginRight: 10,
    marginBottom: 15,
    color: "#5675D3",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    // fontWeight: "bold",
    fontSize: 10,
    backgroundColor: "#E4F1FF",
    minWidth: 90,
    borderWidth: 0,
  },
  row: {
    display: "flex",
    overFlow: "hidden",
    overflowX: "auto",
  },
  carousel: {
    width: "100%",
    height: 360,
    borderBottom: "1px solid #E5E5E5",
  },
  head: {
    padding: 16,
    height: "130px"
  },
  label: {
    backgroundColor: "#FEDEEA",
    fontSize: 12,
    lineHeight: "20px",
    color: "#D60B54",
    display: "inline-block",
    padding: "2px 12px",
    fontWeight: "bold",
    borderRadius: 12,
    marginBottom: 4,
  },
  priceWrapper: {
    display: "flex",
    padding: "16px 0px",
  },
  pricesList: {
    width: "70%",
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  sectionPrice: {
    width: "100%",
    padding: "0px 16px",
    display: "flex",
    flexDirection: "row",
  },
  sectionStock: {
    width: "50%",
    padding: "0px 16px",
    display: "flex",
    flexDirection: "row",
  },
  titlePrice: {
    color: "rgb(136, 136, 136)",
    fontSize: 13,
    width: "30%",
    "@media (max-width: 768px)": {
      minWidth: "120px",
    },
  },
  priceProd: {
    color: "black",
    fontSize: 13,
    fontWeight: "bold",
    // width: "30%",
    // "@media (max-width: 768px)": {
    //   width: "50%",
    // },
  },
  price: {
    fontWeight: 700,
    fontSize: 12,
    color: "#eb6669",
    // textAlign: "center",
    width: "200px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "@media(max-width: 280px)": {
      // width: 100,
    },
    "@media (max-width: 360px)": {
      fontSize: 10,
    },
    "@media(min-width: 960px)": {
      // maxWidth: 150,
    },
  },
  descPrice: {
    display: "flex",
    flexWrap: "wrap",
  },
  descHead: {
    textDecoration: "none",
    padding: "12px 16px",
    display: "flex",
    justifyContent: "space-between",
    color: "inherit",
  },
  descBody: {
    padding: "0px 16px 16px",
    whiteSpace: "pre-line",
  },
  btnWrapper: {
    padding: 16,
  },
  variantContent: {
    padding: 16,
  },
  h3Title: {
    fontSize: 13,
    fontWeight: 400,
    lineHeight: "18px",
    marginBottom: 10,
    color: "#888",
    textTransform: "capitalize",
  },
  btn: {
    textTransform: "capitalize",
  },
  btnCard: {
    color: "#ffff",
    fontWeight: 700,
    fontSize: 12,
    "@media(max-width: 280px)": {
      padding: "4px 4px",
    },
    textTransform: "capitalize",
  },

  loading: {
    width: "100%",
    height: "calc(100vh - 60px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  wrapScroll: {
    display: "flex",
    overflowX: "auto",
    flexWrap: "nowrap",
    padding: "16px",
  },
  wrapper: {
    // display:"inline-table",
    // flex: "0 0 auto",
    paddingLeft: 4,
    paddingRight: 4,
    marginBottom: 15,
    "@media(min-width: 280px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 320px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 360px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 400px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 600px)": {
      width: "calc(100%/3)",
      height: "100%",
    },
    "@media(min-width: 960px)": {
      width: "calc(100%/4)",
      height: "100%",
    },
  },
  card: {
    // flex: "0 0 auto",
    // // width:"200px",
    // height: "100%",
    // borderRadius: 5,
    // boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
    height: "100%",
    borderRadius: 5,
    boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
  },
  labelCard: {
    position: "absolute",
    boxShadow: "2px 2px darkslategrey",
    right: "5px",
    backgroundColor: "#e82868",
    lineHeight: "20px",
    color: "#fff",
    display: "inline-block",
    padding: "5px 5px",
    borderRadius: "0px 0px 20px 20px",
    marginBottom: 4,
    textAlign: "center",
  },
  txtLabel: {
    fontSize: 12,
    color: "#FFF",
  },
  empty: {
    backgroundColor: "hsla(0,0%,100%,.9)",
    width: "100%",
    height: "100%",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  txtEmpty: {
    fontSize: 18,
    fontWeight: 700,
    color: "rgba(0,0,0,.4)",
  },
  txtWhiteBold: {
    fontSize: 14,
    fontWeight: "bold",
    color: "white",
  },
  txtWhite: {
    fontSize: 12,
    color: "white",
  },
  txt: {
    fontSize: 14,
    fontWeight: "bold",
  },
  img: {
    // width: "200px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    "@media(min-width: 280px)": {
      height: 128,
    },
    "@media(min-width: 320px)": {
      height: 148,
    },
    "@media(min-width: 360px)": {
      height: 168,
    },
    "@media(min-width: 960px)": {
      height: 270,
    },
  },
  contentWrapper: {
    height: 170,
    position: "relative",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "0px 10px",
    marginTop: 8,
    justifyContent: "space-between",
    height: 170,
  },
  title: {
    fontWeight: 700,
    fontSize: 14,
    textAlign: "center",
    color: "#333333",
    maxWidth: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "@media(min-width: 280px)": {
      fontSize: 12,
    },
    "@media(min-width: 320px)": {
      fontSize: 12,
    },
    "@media(min-width: 360px)": {
      fontSize: 14,
    },
    "@media(min-width: 960px)": {
      fontSize: 14,
    },
  },
  // price: {
  //   fontWeight: 700,
  //   fontSize: 12,
  //   color: "#eb6669",
  //   // textAlign: "center",
  //   width: "200px",
  //   whiteSpace: "nowrap",
  //   overflow: "hidden",
  //   textOverflow: "ellipsis",
  //   "@media(max-width: 280px)": {
  //     // width: 100,
  //   },
  //   "@media (max-width: 360px)": {
  //     fontSize: 10,
  //   },
  //   "@media(min-width: 960px)": {
  //     // maxWidth: 150,
  //   },
  // },
  txtStockTersedia: {
    fontSize: 12,
    color: "#777777",
    "@media (max-width: 360px)": {
      fontSize: 10,
    },
  },
  txtStock: {
    fontSize: 11,
    "@media (max-width: 360px)": {
      fontSize: 9,
    },
  },
  labelKomisi: {
    backgroundColor: "#FEDEEA",
    fontSize: 10,
    lineHeight: "20px",
    color: "#D60B54",
    display: "inline-block",
    padding: "2px 8px",
    fontWeight: "bold",
    borderRadius: 12,
    marginBottom: 5,
    marginTop: 5,
    // "@media(min-width: 280px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 320px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 360px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 960px)": {
    //   fontSize: 11,
    //   padding: "0 4px",
    // },
  },
  txtLabelharhag: {
    fontSize: 12,
    "@media (max-width: 360px)": {
      fontSize: 10,
    },
  },
  btnWrap: {
    width: "90%",
    position: "absolute",
    bottom: "10px",
    left: "0px",
    right: "0px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  labelNew: {
    backgroundColor: "#E0FFDF",
    fontSize: 10,
    lineHeight: "20px",
    color: "#70A96F",
    display: "inline-block",
    padding: "2px 8px",
    fontWeight: "bold",
    borderRadius: 12,
    // marginLeft: 5,
    // marginBottom: 5,
    marginTop: 5,
    // "@media(min-width: 280px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 320px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 360px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 960px)": {
    //   fontSize: 11,
    //   padding: "0 4px",
    // },
  },
  labelPre: {
    backgroundColor: "#FFF1E3",
    fontSize: 10,
    lineHeight: "20px",
    color: "#D2965E",
    display: "inline-block",
    padding: "2px 8px",
    fontWeight: "bold",
    borderRadius: 12,
    marginRight: 5,
    minWidth: 65,
    // marginBottom: 5,
    marginTop: 5,
    // "@media(min-width: 280px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 320px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 360px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 960px)": {
    //   fontSize: 11,
    //   padding: "0 4px",
    // },
  },
  labelFlash: {
    backgroundColor: "#bde7ff6e",
    fontSize: 10,
    lineHeight: "20px",
    color: "#0088d6f7",
    display: "inline-block",
    padding: "2px 8px",
    fontWeight: "bold",
    borderRadius: 12,
    marginRight: 5,
    // marginBottom: 5,
    marginTop: 5,
    // "@media(min-width: 280px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 320px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 360px)": {
    //   fontSize: 9,
    //   padding: "0 3px",
    // },
    // "@media(min-width: 960px)": {
    //   fontSize: 11,
    //   padding: "0 4px",
    // },
  },
}));

export default useStyles;
